import { AccountActions } from "./action_types"
import { Action } from "./actions"

const accountReducer = (
  initialState: any,
  action: Action
): any => {
  switch (action.type) {
    case AccountActions.LOGIN:
      return {
        ...initialState,
        user: action.payload
      }

    case AccountActions.LOGOUT:
      return {
        ...initialState,
        user: null
      }

    case AccountActions.FETCH_ACCOUNTS:
      return {
        ...initialState,
        users: action.payload
      }

    default:
      return {
        ...initialState,
      }
  }
}

export default accountReducer